import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";


import product from "./product/product.module";
import collection from "./collection/collection.module";
import userManagement from "./user-management/user-management.module";
import purchase from "./purchase/purchase.module";
import moduleAuth from "./auth/moduleAuth.js";
import newsletter from "./newsletter/newsletter.module";
import widget from "./widget/widget.module";
import review from "./review/review.module";
import faq from "./faq/faq.module";
import latestVideo from "./latest-video/latest-video.module";
import advisor from "./advisor/advisor.module";
import usefulLink from "./useful-link/useful-link.module";
import appointment from "./appointment/appointment.module";
import disease from "./disease/disease.module";
import helloDnaProfile from "./hello-dna-profile/hello-dna-profile.module";
import advisorSettlement from './advisor-settlement/advisor-settlement.module';
import adminRoleManagement from "./admin-role-management/admin-role.module";

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    product,
    collection,
    userManagement,
    auth: moduleAuth,
    purchase,
    newsletter,
    widget,
    review,
    faq,
    latestVideo,
    advisor,
    usefulLink,
    appointment,
    disease,
    helloDnaProfile,
    advisorSettlement,
    adminRoleManagement,
  },
  strict: process.env.NODE_ENV !== "production",
});
